import { render } from "./AnagraficaClientiAssegnati.vue?vue&type=template&id=f21913ba&scoped=true"
import script from "./AnagraficaClientiAssegnati.vue?vue&type=script&lang=js"
export * from "./AnagraficaClientiAssegnati.vue?vue&type=script&lang=js"

import "./AnagraficaClientiAssegnati.vue?vue&type=style&index=0&id=f21913ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21913ba"]])

export default __exports__